import _defineProperty from "/runner/_work/miro-site/miro-site/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/runner/_work/miro-site/miro-site/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["theme", "maxWidth", "$styles"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import styled from 'styled-components';
import Box from './Box';
var Container = styled(Box).attrs(function (_ref) {
  var theme = _ref.theme,
      maxWidth = _ref.maxWidth,
      _ref$$styles = _ref.$styles,
      $styles = _ref$$styles === void 0 ? {} : _ref$$styles,
      restProps = _objectWithoutProperties(_ref, _excluded);

  return _objectSpread({
    $mx: 'auto',
    $px: [20, null, null, null],
    $styles: _objectSpread({
      maxWidth: maxWidth || theme.layout.defaultContainerWidth
    }, $styles)
  }, restProps);
}).withConfig({
  displayName: "Container",
  componentId: "sc-gjtwgf-0"
})({});
export default Container;